import api from './api';
import { Certificate } from '../types';

export const certificateService = {
    getAllCertificates: async (): Promise<Certificate[]> => {
        const response = await api.get('/admin/certificates');
        return response.data;
    },

    getCertificateStats: async () => {
        const response = await api.get('/certificates/stats');
        return response.data;
    },

    getAllCertificatesForEmployee: async () => {
        const response = await api.get(`/users/certificates`);
        return response.data;
    },

    downloadCertificate: async (certificateId: string): Promise<{ blob: Blob; filename: string }> => {
        const response = await api.get(`/users/certificates/${certificateId}/download`, {
            responseType: 'blob'
        });
        
        // Extract filename from Content-Disposition header
        let filename = `certificate_${certificateId}.pdf`;
        const contentDisposition = response.headers['content-disposition'];
        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
            if (filenameMatch) {
                filename = filenameMatch[1];
            }
        }
        
        // Check content type and adjust filename if needed
        const contentType = response.headers['content-type'];
        if (contentType && contentType.includes('image/png')) {
            // Server returns PNG certificates - this is expected
            // Ensure filename has correct extension
            if (filename.endsWith('.pdf')) {
                filename = filename.replace('.pdf', '.png');
            }
        }
        
        return { blob: response.data, filename };
    }
}; 